import { useEffect, useState } from "react";
import CircularLoader from "../../../components/common/CircularLoader/CircularLoader";
import { AuthMethods, IIntegrationPartner } from "../../../interfaces/interfaces";
import { ipShortNames } from "../EmailOtp/emailOtpHelper";
import styles from './ConnectionValidation.module.scss';

type Props = {
    ip: IIntegrationPartner;
}

const ConnectionValidation = ({ ip }: Props) => {

    const ipShortName = ipShortNames[ip?.companyName] ?? ip?.companyName;

    // Define messages to cycle through
    const messages = [
        `Verifying ${ipShortName} Credentials...`,
        "Picking Up Your Email...",
        "Checking for Forwarded Emails...",
        "Waiting for Confirmation..."
    ];

    const [messageIndex, setMessageIndex] = useState(0);

    useEffect(() => {
        if (messageIndex < messages.length - 1 && (ip.authMethod == AuthMethods.email_otp || ip?.authMethod == AuthMethods.email_otp_password)) {
            const timer = setTimeout(() => {
                setMessageIndex((prevIndex) => prevIndex + 1);
            }, 30000); // 30 seconds

            return () => clearTimeout(timer); // Cleanup function
        }
    }, [messageIndex, ip]); // Run effect when messageIndex changes

    return (
        <>
            {ip.authMethod == AuthMethods.email_otp || ip?.authMethod == AuthMethods.email_otp_password ?
                <div className={styles.otpLoadingRootContainer}>
                    <CircularLoader height="2.75rem" width="2.75rem" />
                    <div className={styles.titleContainer}>
                        {messages[messageIndex]}
                    </div>
                    <div className={styles.subTitleContainer}>
                        This may take up to 5 minutes.
                        <br />
                        <br />
                        Do not close this window.
                    </div>
                </div>
                : <div className={styles.loadingScreen}>
                    <CircularLoader height="2.75rem" width="2.75rem" />
                    <h1>Connection is in progress!</h1>
                    <div>
                        <p>This may take up to 2 minutes.</p>
                        <p>You may close this window.</p>
                    </div>
                </div>}
        </>
    );
}

export default ConnectionValidation;